/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aicostscolumnfailed3Inputs */

const en_aicostscolumnfailed3 = /** @type {(inputs: Aicostscolumnfailed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed`)
};

const de_aicostscolumnfailed3 = /** @type {(inputs: Aicostscolumnfailed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehlgeschlagen`)
};

/**
* | output |
* | --- |
* | "Failed" |
*
* @param {Aicostscolumnfailed3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aicostscolumnfailed3 = /** @type {((inputs?: Aicostscolumnfailed3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aicostscolumnfailed3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aicostscolumnfailed3(inputs)
	return de_aicostscolumnfailed3(inputs)
});
export { aicostscolumnfailed3 as "aiCostsColumnFailed" }